<template>
  <div class="filling-area">
    <div class="d-flex">
      <div style="border-radius: 10px 10px 0 0"
        class="filling-content wd-100p">
        <div
        ref="scrlbr"
          v-if="rdy"
          :style="
            `height: ${prms.questionShuffle!=undefined && prms.questionShuffle ? 'auto':scrollHeight+'px'} !important; overflow: auto; position: relative;`
          "
          class="filling-scroll"
        >
        
          <div class="mg-x-20 pd-b-20" v-if="mode == 0 && confirmObj.modal">
            <div class="card mg-t-20">
              <div class="card-body text-left bd">
                <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Шалгалтын нэр:</h6>
                <p class="mg-b-0">{{ prms.nm }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="circle"></feather>
                      </div>
                      <div class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Асуултын тоо
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ prms.qCount }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="clock"></feather>
                      </div>
                      <div class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Үргэлжлэх хугацаа
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ getDuration(prms, "hours") }}
                          <sup class="mg-l-5">цаг</sup>
                          {{ getDuration(prms, "minutes") }}
                          <sup class="mg-l-5">минут</sup>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="flag"></feather>
                      </div>
                      <div v-if="prms.hasPayment" class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Оролдлогын төлбөр
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          <span v-show="prms.attemptCount>0">{{ prms.resultCount }}/{{ prms.attemptCount }}</span> {{ prms.budget | formatMoney(0, ".", ",") }} ₮
                        </h6>
                      </div>
                      <div v-else class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Боломжит оролдлого
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ prms.resultCount }}/{{ prms.attemptCount }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="alert alert-warning" role="alert">
              Та хичээлийн шалгалт эхлүүлэх гэж байна. Итгэлтэй байна уу?
            </div>

            <div class="text-center d-flex">
              <button
                v-if="prms.resultCount > 0"
                @click="showLessonExamResult()"
                class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
              >
                Өмнөх үр дүн харах ({{ prms.resultCount }})
              </button>
              <div class="btn-group mg-l-auto">
                <!-- <button
              @click="confirmObj.modal=false"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >Үгүй</button> -->
                <button
                  v-if="!prms.hasPayment"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-success btn-uppercase"
                >
                  Эхлэх
                </button>
                <button
                  v-if="prms.hasPayment && prms.payedInvoice"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
                >
                  Оролдлогыг эхлүүлэх
                </button>
                <button
                  v-if="prms.hasPayment && !prms.payedInvoice && prms.resultCount >= prms.attemptCount"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-warning btn-uppercase"
                >
                  Төлбөр төлөх
                </button>
                <button
                  v-if="prms.hasPayment && prms.resultCount < prms.attemptCount"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-success btn-uppercase"
                >
                  Эхлэх
                </button>
              </div>
            </div>
          </div>

          <div v-else-if="mode == 2" class="card card-widget card-events">
            <!-- <div class="d-flex pd-10">
            <div>
              
            </div>
            <button class=" mg-l-auto btn btn-info btn-xs">Оролдлого +</button>
          </div> -->
            
            <div class="pd-20">
              <apexchart
              type="line"
              height="350"
              :options="chartOptions"
              :series="series"
              :key="chartOptionsKey"
            ></apexchart>

              <ul class="list-unstyled media-list mg-b-0 pd-x-5">
                <li
                  class="media "
                  v-for="(r, i) in lessonExamResults"
                  :key="i"
                  @click="showLessonExamFilled(r)"
                  role="button"
                >
                  <div class="media-left" style="min-width: 50px">
                    <label>{{ r.date | moment("dddd") }}</label>
                    <p>{{ r.date | moment("DD") }}</p>
                  </div>
                  <div class="media-body event-panel-green">
                    <span class="event-time"
                      >{{ r.date | moment("HH:mm") }} -
                      {{ r.finishedAt | moment("HH:mm") }}</span
                    >
                    <h6 class="event-title">
                      {{ r.perc.toFixed(2) }}% (
                      <span v-if="!$store.state.app.isMobile">
                        зарцуулсан хугацаа:
                      </span>
                      {{ getExamDuration(r) }}
                      <sup>минут</sup> )
                    </h6>
                  </div>
                  <div
                    class="mg-l-auto d-flex flex-row align-items-center justify-content-center pd-x-10"
                  >
                    <button class="link text-lowercase text-center" role="button">
                      <span v-if="!$store.state.app.isMobile">
                        Хэрхэн бөглөснийг
                        <br />харах
                      </span>
                      <span v-else> <feather type="eye"></feather></span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else-if="mode == 3" class="pd-10">
            <div v-for="(q, i) in form.questions" :key="i" class="mg-b-20">
              <div
                class="d-flex tx-16 align-items-center"
                :class="{
                  'text-success':
                    q.isFilled &&
                    q.as.filter(x => x.aId == q.answerId && x.isTrue).length >
                      0,
                  'text-danger':
                    q.isFilled &&
                    q.as.filter(x => x.aId == q.answerId && x.isTrue).length ==
                      0,
                  'text-warning': !q.isFilled
                }"
              >
                <div class="mg-r-10 text-muted">
                  <div class="rounded-circle bg-primary ht-50 wd-50">{{(i + 1)}}</div>
                </div>
                <div
                  v-if="q.t == 31"
                  v-html="generateMissingWordsFilled(q)"
                  class="pd-y-5"
                ></div>
                <div v-else v-html="q.q" class="font-weight-normal"></div>
              </div>
              <div v-if="q.t == 1 || q.t == 11"></div>
              <div v-else-if="q.t == 3" class="mg-x-30 mg-b-10">
                <div
                  v-for="(a, ai) in q.as"
                  :key="ai"
                  class="`mg-t-10`"
                  :class="{
                    'text-danger': q.answerId == a.aId && !a.isTrue,
                    'text-success': a.isTrue,
                    'text-warning': !q.isFilled && a.isTrue
                  }"
                >
                  <div class="d-flex tx-14">
                    <div class="mg-r-10 tx-16">
                      <i
                        class="far"
                        :class="{
                          'fa-check-circle': a.isTrue,
                          'fa-times-circle': q.answerId == a.aId && !a.isTrue,
                          'fa-circle': q.answerId != a.aId && !a.isTrue
                        }"
                      ></i>
                    </div>
                    <div class="mg-r-10">{{ alphabetize(ai) }}.</div>
                    <div v-html="a.a"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="mode == 4" class="pd-10">
            <div v-for="(q, i) in form.questions" :key="i" class="mg-b-20">
              <div class="d-flex tx-16">
                <div class="mg-r-10 tx-thin text-muted">{{ i + 1 }}.</div>
                <div v-if="q.t == 31" style="font-weight:500" class="pd-y-5">
                  <div v-html="generateMissingWords(q)"></div>
                </div>
                <div v-else v-html="q.q" style="font-weight:500"></div>
              </div>

              <div class="mg-x-30 mg-b-10">
                <div v-if="q.t == 31" class="alert alert-light tx-13 mg-y-10">
                  Цэгийн оронд тохирох үгийг сонгоно уу
                </div>
                <div
                  v-else-if="q.t == 32 || q.t == 33"
                  style="overflow: hidden; max-width: 100%"
                >
                  <div class="row">
                    <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                      <ul class="list-group" v-if="q.t == 32">
                        <li
                          v-for="(a, i) in sortedAnswers(q)"
                          :key="i"
                          class="list-group-item d-flex align-items-center"
                        >
                          <div>{{ i + 1 }}.</div>
                          <div
                            v-if="a.if"
                            class="mg-l-10 bg-gray-100 pd-y-5 pd-x-10 bd rounded"
                          >
                            {{ a.a }}
                          </div>
                          <button
                            @click="submitExamQuestion(q, a, 0)"
                            class="btn btn-xs btn-icon btn-outline-light mg-l-auto"
                          >
                            <feather type="x"></feather>
                          </button>
                        </li>
                      </ul>
                      <div v-else-if="q.t == 33" class="pyramid">
                        <div
                          @click="submitExamQuestion(q, a, 0)"
                          class="zone"
                          v-for="(a, i) in sortedAnswers(q)"
                          :key="i"
                        >
                          <div v-if="a.if" class="pd-t-50">
                            <div
                              class="bg-white tx-color-02 pd-y-5 pd-x-10 bd pos-relative"
                            >
                              {{ a.a }}
                              <button
                                @click="submitExamQuestion(q, a, 0)"
                                class="btn btn-xs btn-icon btn-outline-light mg-l-auto"
                              >
                                <feather type="x"></feather>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                      <ul class="list-group">
                        <li
                          v-for="(a, i) in q.as.filter(x => !x.if)"
                          :key="i"
                          class="list-group-item d-flex align-items-center"
                        >
                          <button
                            @click="submitExamQuestion(q, a)"
                            class="btn btn-xs btn-icon btn-outline-light mg-r-10"
                          >
                            <feather
                              v-if="q.t == 32"
                              type="chevron-left"
                            ></feather>
                            <feather
                              v-else-if="q.t == 33"
                              type="chevron-up"
                            ></feather>
                          </button>
                          {{ a.a }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="q.t == 3"
                  @click="submitExamQuestion(q, a)"
                  v-for="(a, ai) in q.as"
                  :key="ai"
                  :class="`mg-t-10`"
                  role="button"
                >
                  <div class="d-flex tx-14">
                    <div class="mg-r-10 tx-16">
                      <i
                        :class="
                          `far fa-${
                            q.isFilled && a.aId == q.answerId
                              ? 'check-circle'
                              : 'circle'
                          }`
                        "
                      ></i>
                    </div>
                    <div class="mg-r-10">{{ alphabetize(ai) }}.</div>
                    <div v-html="a.a"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="pd-15">
          <!-- ene mon v -->
            <div
              v-if="form.info != '' && form.info != '<p><br></p>'"
              v-html="form.info"
              class="bd-b mg-b-10"
            ></div>
            <div
              v-for="(q, i) in form.questions"
              :key="i"
              class="mg-b-20 pos-relative" :id="`qa_${q.id}`"
            >
              <div class="d-flex tx-16 tx-gray-600">
                <div class="mg-r-10 tx-thin text-muted">{{ i + 1 }}.</div>
                <div v-if="q.t == 31" style="font-weight:500" class="pd-y-5">
                  <div v-html="generateMissingWords(q)"></div>
                </div>
                <div v-else v-html="q.s1" style="font-weight: 500"></div>

                <div
                  v-show="
                    q.t == 3 &&
                      !q.isFilled &&
                      q.a.filter(x => x.isFilled).length
                  "
                  class="pos-absolute r-30 b-20"
                >
                  <button
                    @click="submitExamQuestion(q, null, 1)"
                    class="btn btn-xs btn-uppercase btn-info "
                  >
                    Хадгалах
                  </button>
                </div>
              </div>
              <div
                class="mg-l-25 bd-l bd-5 pd-x-10 pd-y-5 bg-gray-100 mg-b-5 tx-color-03"
                v-if="q.s2 != null && q.s2 != ''"
              >
                {{ q.s2 }}
              </div>
              <div
                v-if="q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24"
                class="mg-x-30 mg-b-10"
              >
                <div v-if="prms.questionShuffle!=undefined && prms.questionShuffle" class="d-flex mg-t-10">
                  <div @click="q.t == 3 ? submitExamQuestion(q, a, 0) : submitQuestion(q, a)"
                    role="button" v-for="(a, ai) in q.a" :key="ai" :class="`${getBg(q, a)} bd bd-1 rounded-${q.t==4?'20':'10'} mg-r-20 pd-x-17 pd-y-10`" 
                  style="padding-left: 17px; padding-right: 17px">
                    {{a.s1}}
                  </div>
                </div>
                <template v-else>


                  <div  v-for="(a, ai) in q.a" :key="ai"
                  :class="`mg-t-10 ${getColor(q, a)}`">
                  <div
                    class="d-flex tx-14"
                    @click="
                      q.t == 3
                        ? submitExamQuestion(q, a, 0)
                        : submitQuestion(q, a)
                    "
                    role="button"
                  >
                    <div class="mg-r-10 tx-16">
                      <i
                        v-if="q.t == 4 || q.t == 23 || q.t == 24"
                        :class="
                          `far fa-${a.isFilled ? 'check-circle' : 'circle'}`
                        "
                      ></i>
                      <i
                        v-else-if="q.t == 3"
                        :class="
                          `far fa-${a.isFilled ? 'check-square' : 'square'}`
                        "
                      ></i>
                    </div>
                    <div v-if="form.flag != 700" class="mg-r-10">
                      {{ alphabetize(ai) }}.
                    </div>
                    <div v-html="a.s1"></div>
                    <!-- {{a}} -->
                  </div>
                  <div
                    v-show="q.t == 23 && a.isFilled == true"
                    class="pos-relative"
                  >
                    <!-- @input="fillForm(q, a)" -->
                    <Input
                      maxlength="4000"
                      v-model="a.str"
                      size="mini"
                      placeholder="Тайлбар бичнэ үү"
                      type="textarea"
                      :rows="3"
                    />
                    <button
                      @click="submitQuestion(q, q.a[0], q.a[0].str, true)"
                      class="btn btn-xs btn-uppercase btn-info pos-absolute r-5 b-5"
                    >
                      Хадгалах
                    </button>
                  </div>
                  <div
                    class="mg-l-25 bd-l bd-5 pd-x-10 pd-y-5 bg-gray-100 tx-color-03"
                    v-if="a.i != null && a.i != ''"
                  >
                    {{ a.i }}
                  </div>
                </div>


                </template>
                
                
              </div>
              <div
                v-else-if="q.t == 1 || q.t == 7 || q.t == 11"
                class="mg-x-30 mg-b-10 pos-relative"
              >
                <!-- @input="submitQuestion(q, q.a[0], q.a[0].s1)" -->
                <Input
                  v-model="q.a[0].s1"
                  :type="q.t == 11 ? 'textarea' : 'text'"
                  :rows="q.t == 11 ? 4 : 1"
                  placeholder="Энд бичнэ үү"
                />
                <button
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-info pos-absolute r-5 b-5"
                >
                  Хадгалах
                </button>
              </div>
              <div v-else-if="q.t == 21" class="mg-x-30 mg-b-10">
                <InputNumber v-model="q.a[0].s1"></InputNumber>
                <button
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-info mg-l-5"
                >
                  Хадгалах
                </button>
              </div>
              <div v-else-if="q.t == 22" class="mg-x-30 mg-b-10">
                <!-- @change="fillForm(q, q.as[0], $event)" -->
                <DatePicker
                  type="date"
                  v-model="q.a[0].s1"
                  :format="'yyyy-MM-dd'"
                  :value-format="'yyyy-MM-dd'"
                ></DatePicker>
                <button
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-info mg-l-5"
                >
                  Хадгалах
                </button>
              </div>
              <div
                v-else-if="q.t == 31"
                class="alert alert-light tx-13 mg-y-10 mg-x-30"
              >
                Цэгийн оронд тохирох үгийг сонгоно уу
              </div>
              <div v-else class="mg-x-30 mg-b-10">...</div>
              <!-- <div v-else>{{q.a}} {{q.t}}</div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        style="max-height: calc(100vh - 170px); overflow: auto"
        :class="
          `filling-sidebar wd-20p bd-l bg-${
            $store.state.app.skin.dark ? 'dark' : 'white'
          }`
        "
      >
        <div v-if="mode == 4">
          <div
            id="countdownRight"
            class="exam-timer bg-gray-100 text-center tx-32 pd-y-20"
          ></div>
        </div>

        <fill-sidebar
          :mode="mode"
          :form="form"
          :prms="prms"
          @finishLessonExam="finishLessonExam($event)"
          @showLessonExamResult="showLessonExamResult()"
          @refillLessonExam="refillLessonExam()"
        />
      </div> -->
    </div>
    <div v-if="!hideFooter" class="d-flex pd-x-15 pd-y-10 bg-gray-100 bd-t" style="border-radius: 0 0 10px 10px;">
      <div class="d-flex wd-100p align-items-center">
        <div>
          <button
            @click="reFill(0)"
            class="btn btn-light"
            v-if="boxOt == 117 && prms.qCount > 0">
          <!-- && prms.fillingCount == prms.qCount -->
            <feather type="refresh-cw" class="mg-r-5"></feather>
            дахин бөглөх
          </button>
          <button
            @click="reFill(1)"
            v-if="(boxOt == 389 || boxOt == 503) && rdy"
            class="btn btn-light mg-l-auto"
          >
            Дуусгах
          </button>
          <div v-if="mode == 4">
            <div
              id="countdown"
              class="exam-timer bg-gray-100 text-center tx-16 text-primary"
            ></div>
          </div>
        </div>
        <div class="btn-group mg-l-auto">
          <button
            v-if="mode == 4"
            @click="finishLessonExam(form.resultId)"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Дуусгах
          </button>
          <button
            v-if="mode == 4"
            @click="rightSideBarChanged(true)"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Явц
          </button>
          <button
            v-if="
              (prms.resultCount < prms.attemptCount && mode == 2) ||
                (prms.hasPayment && mode == 2)
            "
            v-on:click="refillLessonExam()"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Дахин оролдох
          </button>

          <button
            v-if="mode == 3"
            v-on:click="
              form.questions = [];
              mode = 2;
            "
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
          >
            Үр дүнгүүд
          </button>
          <button
            v-if="!lessonDone"
            @click="$emit('on-lesson-finish')"
            :class="
              `btn mg-l-15 btn-xs pd-x-15 btn-outline-${
                $store.state.app.skin.dark ? 'white' : 'primary'
              } btn-icon btn-uppercase`
            "
            title="Хичээлийг дуусгах ?"
          >
            <feather
              type="check-square"
              size="16"
              title="Хичээлийг дуусгах ?"
            ></feather>
            Хичээлийг дуусгах ?
          </button>
        </div>
      </div>
    </div>

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button
              variant="outline-success"
              @click="busyMode == 0 ? reFillDo() : finishSurvey()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>

    <b-sidebar v-model="mydataaa" right width="100vw">
      <div class="pd-5 bg-white">
        <fill-sidebar
          :mode="mode"
          :form="form"
          :prms="prms"
          @finishLessonExam="
            finishLessonExam($event);
            rightSideBarChanged(false);
          "
          @showLessonExamResult="
            showLessonExamResult();
            rightSideBarChanged(false);
          "
          @refillLessonExam="
            refillLessonExam();
            rightSideBarChanged(false);
          "
        />
      </div>
    </b-sidebar>

    <b-modal
      v-model="filled.sidebar"
      hide-footer
      scrollable
      centered
      title="Бөглөсөн"
      modal-class="full-mdl"
    >
      <div class="mg-b-30" >
        <div class="d-flex flex-column align-items-center justify-content-center">
        <img :src="`${myResBaseUrl}v4-assets/exam_passed.png`" />
        <h3>Та {{filledResult.perc}}% авлаа</h3>
        <div class="text-muted mg-b-20">Танд одоо {{ prms.attemptCount - prms.resultCount}} удаа шалгалт өгөх эрх байна</div>
        <div style="" class="mg-b-30">
          <div style="width: 100%; display: grid; grid-template-columns: repeat(8, 1fr); grid-template-rows: repeat(auto-fill, auto-fill); grid-row-gap: .5em; grid-column-gap: 1em;">
            
            <template v-for="ss in filledResult.form.sections">
              <div v-for="(q,i) in filledResult.form.questions.filter(x=>x.sId==ss.id)" :key="i" 
                class="bd rounded-20 d-flex align-items-center mg-x-10 mg-b-10 text-center font-weight-bold"
                style="flex-direction: column">
                  
                    <div class="rounded-circle bg-light pd-x-15 pd-y-10">
                      {{ ((i+1)<10? '0':'') + (i+1) }}
                    </div>
                    <div class="pd-10">
                      <feather :type="q.isTrue?'check':'x'"
                      :style="`width: 20px; height: 20px; color: ${q.isTrue?'#10b759':'#dc3545'};`"></feather>
                      <!-- {{ q.questionOrd }} -->
                    </div>
                </div>
            </template>
          </div>
        </div>

        <div class="">
          <button @click="filled.sidebar= false" class="btn btn-white btn-lg">Хаах</button>
          <button @click="filled.sidebar= false; refillLessonExam(true)" v-if="(prms.attemptCount - prms.resultCount)>0" class="btn btn-primary btn-lg mg-l-20">Шалгалт эхлүүлэх</button>
        </div>
          
        </div>
      </div>
      <div class="" >
        <!-- bg-white rounded-20 bd -->
        <!-- style="display: none;" -->
        <form-filled 
          :id.sync="filled.formId"
          :userId="filled.userId"
          :mode="1"
          @hide-res="filled.sidebar= false"
          @on-result-loaded="resultLoaded"
        />
      </div>
    </b-modal>

    <b-modal
      v-model="tnxModal"
      hide-footer
      centered
      title="Баярлалаа"
      hide-header
      no-close-on-backdrop
    >
      <div class="mg-x-20">
        <div class="text-center pd-20">
          <feather
            type="smile"
            :size="64"
            class="mg-b-20 text-success"
          ></feather>
          <h5
            class="text-truncate tx-14-f"
            style="white-space: normal; max-height: 40px; min-height: 40px"
          >
            Та судалгааг бөглөж дуусгалаа. Танд баярлалаа
          </h5>
        </div>
        <div class="text-center">
          <div>
            <button
              @click="tnxModalHide()"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >
              Хаах
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { romanize, alphabetize } from "@/libs/tools";
import { request } from "@/api/all";
import { Message, Notification, Input, InputNumber, DatePicker } from "element-ui";

var _ = require("lodash");
const moment = require("moment");
var downloadTimer;
import Cookies from "js-cookie";
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";

import wordselect from "@/views/main/exam/wordselect.vue";
import Vue from "vue";
import Buttons from "../../../task/components/transfers/buttons.vue";

export default {
  components: {
    apexchart: VueApexCharts,
    vueCustomScrollbar,
    Input,
    InputNumber,
    DatePicker,
    Notification,
    fillSidebar: () => ({
      component: import("@/components/modules/form/fill/component/sidebar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formFilled: () => ({
      component: import("@/components/modules/form/filled"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    Buttons
  },
  props: {
    id: {
      type: Number,
      default: () => null
    },
    boxId: {
      type: Number,
      default: () => null
    },
    boxOt: {
      type: Number,
      default: () => null
    },
    prms: {
      type: Object,
      default: () => {}
    },
    course: {
      type: Object,
      default: () => {}
    },
    rightSideBar: {
      type: Boolean,
      default: () => false
    },
    lessonDone: {
      type: Boolean,
      default: () => false
    },
    hideFooter: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      missingWordSelectRendered: false,
      form: {
        questuins: [],
        sections: [],
        flat: null
      },
      mode: 0,
      rdy: false,
      rdyMode: 0,

      processing: false,
      busy: false,
      busyMode: 0,
      processingObj: 0,
      processingMode: 0,

      confirmObj: {
        modal: false
      },

      lessonExamResults: [],
      lessonExamResultActive: {
        id: null
      },
      series: [
        {
          name: "%",
          data: []
        }
      ],
      chartOptionsKey: 0,
      chartOptions: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: []
        }
      },
      tnxModal: false,
      //showRightSideBar: false
      mydataaa: false,

      filled: {
        userId: "",
        formId: null,
        sidebar: false
      },
      _cid: null,
      scrollHeight: 0,
      filledResult:{
        form: [],
        sections: [],
        perc: null,
        canViewResult: null,
      },
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    //console.log('fill fired', this.$props, this.id, this.boxOt);
    this.$emit("form-page-rdy");
    request({
      api: { method: "POST", url: "Auth/RefreshToken" },
      store: this.$store
    }).then(res => {
      if (res != false) {
        Cookies.set("token", res.token, { expires: 1 });
        this.init(this.id);
      }
    });
    window.addEventListener("resize", this.getMainHeight);
    this.getMainHeight();

    
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMainHeight);
  },
  destroyed() {
    Object.assign(this.$data, this.$options.data());
    clearInterval(downloadTimer);
    //this.finishLessonExam(this.form.resultId);
  },
  methods: {
    goToQ(e){
      const container = this.$refs.scrlbr;
      const section = document.getElementById(`qa_${e}`);

      if (container && section) {
        console.log('section', section, section.offsetTop, container);
        container.scrollTop = section.offsetTop;
      }

      // console.log('e', e);
      // var targetElement = document.getElementById(`qa_${e}`);
      // if (targetElement) {
      //   targetElement.scrollTop = targetElement.clientHeight;
      //   targetElement.scrollIntoView({
      //     behavior: 'smooth', // Optional: animated smooth scroll
      //     //block: 'start',      // Optional: align the top of the element to the top of the window
      //   });
      // }
    },
    ...mapActions(["handleMainLayoutConfig"]),
    resultLoaded(e){
      //[0]['perc']
      //.filter(x=>x.id==e.reult.id)
      //console.log('e.result.canViewResult', e);
      this.filledResult.form= e.form;
      //this.filledResult.sections= e.sections;
      this.filledResult.perc= (this.lessonExamResults.filter(x=>x.id==e.result.id)[0]['perc']).toFixed(2);
      this.filledResult.canViewResult= e.result.canViewResult;
    },
    showLessonExamFilled(f) {
      this.filled.formId = f.id;
      this.filled.userId = this.$store.state.user.userId;
      this.filled.sidebar = true;
      //console.log(f);
      // this.$emit("on-toggle-class", {
      //   mode: "addClass",
      //   class: "dynamic-locker",
      // });
      // request({
      //   //LessonExamFilledData
      //   api: { method: "POST", url: "V2/Form/LessonExamFilledData" },
      //   data: { id: f.id },
      //   store: this.$store,
      // }).then((res) => {
      //   this.$emit("on-toggle-class", {
      //     mode: "removeClass",
      //     class: "dynamic-locker",
      //   });
      //   if (res != false) {
      //     //console.log("LessonExamFilledData=> ", res);
      //     this.form = res.data.form;
      //     this.mode = 3;
      //     this.lessonExamResultActive.id = f.id;
      //   } else {
      //     this.mode = 2;
      //   }
      // });
    },
    showLessonExamResult() {
      this.confirmObj.modal = false;

      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "GET", url: "V2/learn/GetLessonExamResult" },
        params: {
          examId: this.id,
          courseId: this.$route.params.cid,
          lessonId: this.$route.params.id,
          boxId: this.$route.params.bid,
          objectTypeId: this.$route.params.bot
        },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        //console.log("GetLessonExamResult=> ", res);
        if (res != false) {
          this.lessonExamResults = res.data.results;

          this.series[0].data = res.data.results.map(x => {
            return x.perc.toFixed(0);
          });
          this.chartOptions.xaxis.categories = res.data.results.map(x => {
            return moment(x.date).format("MM.DD HH:mm");
          });
          this.chartOptionsKey++;

          this.mode = 2;
          this.rdy = true;
        }
      });
    },
    lessonExamStarted(m) {
      //console.log(m);
      let _obj = this.$store.state.app.mainLayoutConfig;
      if (!m) {
        _obj.header = 2;
        _obj.expanded = false;
      } else {
        _obj.header = null;
        _obj.expanded = true;
      }

      this.handleMainLayoutConfig(_obj);
      this.$nextTick(() => {
        this.$emit("lesson-exam-started", m);
      });
    },
    startLessonExam() {
      //exam yed back disable
      window.examBackDisabled = true;

      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        if (res != false) {
          if (moment(res.data.now).isBefore(this.$props.course.date.end)) {
            //console.log(1);
            this.$router.push({
              name: "examOnline",
              params: {
                courseId: this.$route.params.cid,
                formId: this.id,
                lessonId: this.$route.params.id,
                boxId: this.$route.params.bid,
                boxOt: this.$route.params.bot
              }
            });
          } else {
            Notification.warning({
              message: "Үргэлжлэх хугацаа дууссан байна",
              duration: 3000,
              type: "warning",
              position: "top-right",
              offset: 50
            });
            //console.log(2);
          }
        }
      });

      // console.log(this.$props.course);
      // if(this.$props.course!=undefined && this.$props.course!=null){
      //   if(this.$props.course.date!=undefined && this.$props.course.date.end!=undefined){
      //     console.log('this.$props=> ', this.$props.prms.sd, this.$props.course.date.end, moment(this.$props.prms.sd).isBefore(this.$props.course.date.end));
      //   }
      // }

      // this.$router.push(
      // {
      //   name: 'examOnline',
      //   params: {
      //     courseId: this.$route.params.cid,
      //     formId: this.id,
      //     lessonId: this.$route.params.id,
      //     boxId: this.$route.params.bid,
      //     boxOt: this.$route.params.bot
      //   }
      // });

      // //console.log("startLessonExam fired");
      // let self = this;
      // this.$emit("on-toggle-class", {
      //   mode: "addClass",
      //   class: "dynamic-locker",
      // });
      // request({
      //   api: { method: "GET", url: "V2/learn/GetLessonExamData" },
      //   params: {
      //     id: this.id,
      //     courseId: this.$route.params.cid,
      //     lessonId: this.$route.params.id,
      //     boxId: this.$route.params.bid,
      //     objectTypeId: this.$route.params.bot,
      //   },
      //   store: this.$store,
      // }).then((res) => {
      //   //console.log("GetLessonExamData=> ", res);
      //   this.$emit("on-toggle-class", {
      //     mode: "removeClass",
      //     class: "dynamic-locker",
      //   });
      //   if (res != false) {
      //     if (this.boxOt == 416) {
      //       this.lessonExamStarted(true);
      //     }
      //     if (res.data.form.totalSecs > 0) {
      //       this.mode = 4;

      //       let _dta = res.data.form;
      //       if (res.data.form.as != undefined && res.data.form.as == 1) {
      //         _dta.questions.map((e) => {
      //           e.as = _.shuffle(e.as);
      //           return e;
      //         });
      //       }

      //       if(!this.missingWordSelectRendered){
      //         this.$nextTick(()=>{
      //           this.missingWordSelectRendered= true;

      //           res.data.form.questions.filter(x=>x.t==31).forEach(q=>{
      //             for (let k=1; k<=q.agc; k++) {
      //               let optns= q.as.filter(x=>x.g==k).map((answr)=> { return {aId: answr.aId, a: answr.a, isFilled: answr.if } });
      //               this.createMissingWordSelect(q.qId, k, optns);
      //             }
      //           });
      //         });
      //       }

      //       this.form = _dta;
      //       this.confirmObj.modal = false;
      //       this.rdy = true;

      //       var timeleft = res.data.form.totalSecs;
      //       var downloadTimer = setInterval(function() {
      //         if (timeleft <= 0) {
      //           clearInterval(downloadTimer);
      //           //resg
      //           //self.reFillDo();
      //           self.finishLessonExam(self.form.resultId);
      //         } else {
      //           if (document.getElementById("countdown") != null) {
      //             document.getElementById("countdown").innerHTML = self.dispHM(
      //               timeleft
      //             );
      //           } else {
      //             clearInterval(downloadTimer);
      //           }

      //           if (document.getElementById("countdownRight") != null) {
      //             document.getElementById("countdownRight").innerHTML = self.dispHM(
      //               timeleft
      //             );
      //           }
      //         }
      //         timeleft -= 1;
      //       }, 1000);
      //     } else {
      //       clearInterval(downloadTimer);
      //       this.reFillDo();
      //     }
      //   }
      // });
    },
    dispHM(m) {
      let rv = "";
      rv =
        '<span class="tmrdigit">' +
        Math.floor(m / 60) +
        '</span> <span>мин</span> <span class="tmrdigit">' +
        (Math.floor(m % 60) > 0
          ? Math.floor(m % 60) + "</span> <span>cек</span>"
          : "");
      return rv;
    },
    forceInterval() {
      Object.assign(this.$data, this.$options.data());
      //console.log("forceInterval fire on filling page");
      clearInterval(downloadTimer);
    },
    init(id) {
      //console.log('this.boxOt', this.boxOt);
      if (this.boxOt == 416) {
        clearInterval(downloadTimer);
        //console.log('this.prms.resultCount', this.prms.resultCount);
        //console.log('this.prms', this.prms);
        if (this.prms.resultCount > 0) {
          //console.log('this.prms.resultCount == this.prms.attemptCount', this.prms.resultCount == this.prms.attemptCount);
          if (
            this.prms.resultCount == this.prms.attemptCount &&
            !this.prms.hasPayment
          ) {
            //console.log("oroldlogo duussan bna ur dvn haruulna");
            this.confirmObj.modal = false;
            this.showLessonExamResult();
          } else {
            this.$emit("on-toggle-class", {
              mode: "addClass",
              class: "dynamic-locker"
            });
            request({
              api: { method: "GET", url: "learn/HasNotFinishedLessonExams" },
              params: {
                formId: id,
                courseId: this.$route.params.cid,
                lessonId: this.$route.params.id,
                boxId: this.$route.params.bid,
                objectTypeId: this.$route.params.bot
              },
              store: this.$store
            }).then(res => {
              this.$emit("on-toggle-class", {
                mode: "removeClass",
                class: "dynamic-locker"
              });
              if (res != false) {
                if (res.data.hasNotFinishedLessonExams) {
                  this.startLessonExam();
                } else {
                  this.confirmObj.modal = true;
                  this.rdy = true;
                }
                //console.log("NotFinishedLessonExams", res);
              }
            });
          }
        } else {
          //console.log("anh udaa bugluh gej bna");
          this.confirmObj.modal = true;
          this.rdy = true;
        }
      } else {
        this.rdy = false;
        this.$emit("on-toggle-class", {
          mode: "addClass",
          class: "dynamic-locker"
        });
        let _cid=null;
        if(this.$route.params.cid!=undefined && this.$route.params.cid!=null){
          _cid= this.$route.params.cid;
        }else if(this.$route.params.id!=undefined && this.$route.params.id!=null){
          _cid= this.$route.params.id;
        }
        this._cid= _cid;
        // console.log('_cid', _cid);
        request({
          api: { method: "GET", url: "Form/GetLatestResponse" },
          params: { form: id, courseId: _cid },
          store: this.$store
        }).then(res => {
          console.log('Form/GetLatestResponse=> ', id, res);
          this.$emit("on-toggle-class", {
            mode: "removeClass",
            class: "dynamic-locker"
          });
          if (res != false) {
            this.form = res.data;
            this.$emit('on-fetch-sidebar', 
              {
                form: this.form,
                mode: this.mode,
                prms: this.prms,
                rdy: true
              }
            );
            //console.log('this.form', this.form);

            if (!this.missingWordSelectRendered) {
              this.$nextTick(() => {
                this.missingWordSelectRendered = true;
                this.form.questions
                  .filter(x => x.t == 31)
                  .forEach(q => {
                    //console.log(q,q.a[0])
                    for (let k = 1; k <= q.agc; k++) {
                      //console.log(q.a,q.a.filter(x=>x.g==k));
                      let optns = q.a
                        .filter(x => x.g == k)
                        .map(answr => {
                          return {
                            aId: answr.id,
                            a: answr.s1,
                            isFilled: answr.isFilled
                          };
                        });
                      this.createMissingWordSelect(q.id, k, optns);
                    }
                  });
              });
            }

            this.rdy = true;
          } else {
            this.$emit("activate-modal-close");
            // if (this.$route.name == "lmsCourseView") {
            //   this.$router.push({
            //     name: "lmsCourseView",
            //     params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
            //   });
            // }
            this.surveyOverView(id, _cid);
            //# hicheeliin huuchin lesson overview haragdaad bsn tul boliv 2021.11.19
            // else if(this.$route.name=='lmsLessonView'){
            //   this.$router.push({
            //     name: "lmsLessonView",
            //     params: {
            //       id: this.$route.params.id,
            //       cid: this.$route.params.cid,
            //       bid: 0,
            //       iid: 0,
            //       bot: 0,
            //     },
            //   });
            // }
          }
        });
      }
    },
    surveyOverView(id, cid) {
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "GET", url: "Form/GetLatestFormCheckedData" },
        params: {
          form: id,
          courseId: cid,
        },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        if (res != false) {
          this.form = res.data;
          this.rdy = true;
          //console.log("Form/GetLatestFormCheckedData=> ", res);
        }
      });
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    submitQuestion(q, a, str, isForce) {
      //console.log('submitQuestion fired', q.t, q, a, str, isForce);
      let _data = {
        formId: this.id,
        questionId: q.id,
        answerId: a.id,
        str: str,
        courseId: this._cid
      };
      //console.log(q.t);
      if (q.t == 1 || q.t == 7 || q.t == 11 || q.t == 21 || q.t == 22) {
        _data = {
          formId: this.id,
          questionId: q.id,
          str: str,
        courseId: this._cid
        };
      } else if (
        (q.t == 3 || q.t == 4 || (q.t == 23 && isForce) || q.t == 24) &&
        a.isResponse &&
        a.isFilled
      ) {
        _data = {
          formId: this.id,
          questionId: q.id,
          answerId: a.id,
          str: str,
        courseId: this._cid
        };
      }
      if (q.t == 1 || q.t == 7 || q.t == 11 || q.t == 21 || q.t == 22) {
        //console.log('fire => Form/CheckQuestionPost');
        request({
          api: { method: "POST", url: "Form/CheckQuestionPost" },
          data: _data,
          store: this.$store
        }).then(res => {
          //console.log('Form/CheckQuestionPost=> ', res);
          if (res != false) {

            // Notification.warning({
            //   message: "Амжилттай",
            //   duration: 3000,
            //   type: "success",
            //   position: "bottom-right",
            //   offset: 50
            // });
            Message('Амжилттай');
            q.isFilled = str != undefined && str != "";
            a.isFilled = str != undefined && str != "";
            this.$emit("on-form-filled", {
              id: this.id,
              boxId: this.boxId,
              fillingCount: this.form.questions.filter(x => x.isFilled).length
            });
          }
        });
      } else if (q.t == 3 || q.t == 4 || (q.t == 23 && isForce) || q.t == 24) {
        //&& a.isResponse && a.isFilled
        //console.log('fire => Form/CheckQuestion');
        request({
          api: { method: "POST", url: "Form/CheckQuestion" },
          params: _data,
          store: this.$store
        }).then(res => {
          //console.log('Form/CheckQuestion=> ', res);
          //this.toggleBodyClass('removeClass', 'dynamic-locker');
          if (res != false) {
            if (q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24) {
              if (q.t == 4 || q.t == 23) {
                q.a.forEach(e => {
                  e.str = e.id == a.id ? e.str : "";
                  e.isFilled = e.id == a.id;
                });
              } else if (q.t == 3 || q.t == 24) {
                a.isFilled = !a.isFilled;
              } else {
                if (str == undefined) {
                  a.str = "";
                  a.isFilled = !a.isFilled;
                }
              }

              q.isFilled = q.a.filter(x => x.isFilled).length > 0;
            } else {
              q.isFilled = str != undefined && str != "";
              a.isFilled = str != undefined && str != "";
            }

            this.$emit("on-form-filled", {
              id: this.id,
              boxId: this.boxId,
              fillingCount: this.form.questions.filter(x => x.isFilled).length
            });
          }
        });
      } else if (q.t == 23 && !a.isFilled) {
        q.a.forEach(e => {
          e.str = e.id == a.id ? e.str : "";
          e.isFilled = e.id == a.id;
        });
      } else {
        //console.log('post hiisengui => ', a.isResponse , a.isFilled);
      }
    },
    getBg(q, a) {
      let rv;
      if(a!=undefined){
        if(a.isFilled){
          rv='bg-primary tx-white bd-primary';
        }
      }
      return rv;
    },
    getColor(q, a) {
      let rv;
      if (a != undefined) {
        if (
          this.prms.flag != undefined &&
          this.prms.flag == 700 &&
          q.isFilled &&
          a.isFilled
        ) {
          rv = "text-primary";
        } else {
          if (this.prms.flag != undefined && this.prms.flag == 800) {
            if (q.isFilled && a.isFilled && a.b1 == 100) {
              rv = "text-success";
            } else if (q.isFilled && a.isFilled && a.b1 != 100) {
              rv = "text-warning";
            } else if (q.isFilled && a.b1 == 100) {
              rv = "text-success";
            }
          }
        }
      } else {
        if (
          this.prms.flag != undefined &&
          this.prms.flag == 700 &&
          q.isFilled &&
          q.a.filter(x => x.isFilled).length
        ) {
          rv = "text-primary";
        } else if (
          q.isFilled &&
          q.a.filter(x => x.isFilled && x.b1 == 100).length
        ) {
          rv = "text-success";
        } else if (
          q.isFilled &&
          q.a.filter(x => x.isFilled && x.b1 != 100).length
        ) {
          rv = "text-warning";
        } else if (
          (q.t == 1 || q.t == 7 || q.t == 11) &&
          q.isFilled &&
          q.a.filter(x => x.s1 != null || x.s1 != "").length
        ) {
          rv = "text-primary";
        }
      }
      return rv;
    },
    reFill(m) {
      this.busyMode = m;
      this.busy = true;
      // this.$emit('on-toggle-class', {mode: 'addClass', class: 'dynamic-locker' })
      // request({
      //   api: { method: "POST", url: "Form/TestRefill" },
      //   params: { id: this.id },
      //   store: this.$store
      // }).then(res => {
      //   this.$emit('on-toggle-class', {mode: 'removeClass', class: 'dynamic-locker' })
      //   console.log(res);
      //   if (res != false) {
      //       this.init(this.id);
      //       this.$emit('on-reload')
      //   }
      // });
    },
    reFillDo() {
      this.processing = true;
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "POST", url: "Form/TestRefill" },
        params: { id: this.id },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        this.processing = false;
        this.busy = false;
        if (res != false) {
          clearInterval(downloadTimer);
          this.init(this.id);
          this.$emit("on-reload");
        }
      });
    },
    finishSurvey() {
      this.processing = true;
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "POST", url: "Form/SurveyRefill" },
        params: { id: this.id },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        //console.log('Form/SurveyRefill', res);
        if (res != false) {
          this.processing = false;
          this.busy = false;
          this.tnxModal = true;
          //console.log('res', res);
        }
      });
    },
    tnxModalHide() {
      this.tnxModal = false;
      if (this.$route.name == "lmsCourseView") {
        this.$router.push({
          name: "lmsCourseView",
          params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
        });
      } else {
        this.$emit("nav-dynamic-update", this.$route.params.id);
      }
    },
    getDuration(prms, mode) {
      return moment
        .duration(moment(prms.ed).diff(moment(prms.sd)))
        .get(mode);
    },
    getExamDuration(form) {
      return moment
        .duration(moment(form.finishedAt).diff(moment(form.date)))
        .get("minutes");
    },
    submitExamQuestion(q, a, gId) {
      //console.log('submitExamQuestion', q,a,gId);
      if (q.isFilled) {
        this.$bvToast.toast("Бөглөсөн байна!", {
          title: "Мэдэгдэл",
          autoHideDelay: 500,
          appendToast: false
        });
        return false;
      }

      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "POST", url: "V2/Form/CheckExamQuestion" },
        params: {
          formId: this.id,
          questionId: this.mode == 0 ? q.id : q.qId,
          answerId: a != null ? (this.mode == 0 ? a.id : a.aId) : null,
          resultId: this.form.resultId,
          grpId: gId
        },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        //console.log('V2/Form/CheckExamQuestion', res);
        if (res != false) {
          if (q.t == 32 || q.t == 33 || q.t == 34) {
          } else if (q.t == 3) {
            if (gId == 1) {
              q.isFilled = true;
            }
            if (a != null) {
              a.isFilled = !a.isFilled;
            }
          } else {
            q.isFilled = true;
            q.answerId = a != null ? a.aId : null;
            if (a != null) {
              a.isFilled = true;
            }
          }
        }
      });
    },
    finishLessonExam(resultId) {
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker"
      });
      request({
        api: { method: "POST", url: "Form/ResultEnd" },
        data: { id: resultId },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker"
        });
        if (res != false && res.data.result == 1) {
          this.lessonExamStarted(false);
          clearInterval(downloadTimer);
          this.$emit("on-update-result-count", this.id);
          this.showLessonExamResult();
          this.form.questions = [];
        }
      });
    },
    refillLessonExam(direct) {
      //console.log(this.mode);
      this.mode = 0;
      //console.log(this.mode);
      this.confirmObj.modal = true;
      if(direct!=undefined && direct){
        this.startLessonExam();
      }
    },
    rightSideBarChanged(e) {
      this.mydataaa = e;
      // if (!e) {
      //   this.$emit("on-close-right-sidebar");
      // }else{
      //   this.$emit("on-close-right-sidebar");
      // }
    },
    getMainHeight() {
      let rv = "";
      let mh = 170;

      if (this.mode == 4) {
        mh = 55;
      }

      if (this.$store.state.app.isMobile && this.mode == 4) {
        //mh=110;
        mh = 55;
      } else if (this.$store.state.app.isMobile) {
        mh = 165;
      }
      rv = window.innerHeight - mh;
      //calc(100vh - 170px)
      //console.log(rv, mh);
      //console.log(rv);
      //alert(mh);
      this.scrollHeight = rv;
    },

    //# hicheeliin shalgaltiin shine asuultiin turlvvd
    createMissingWordSelect(qId, gId, answers) {
      var ComponentClass = Vue.extend(wordselect);
      var instance = new ComponentClass({
        propsData: {
          gId: gId,
          qId: qId,
          answers: answers
        },
        parent: this
      });
      instance.$;
      //instance.$slots.default = ["Click me!"];
      instance.$mount(); // pass nothing
      instance.$on("change", e => this.missingChanged(e));
      document.getElementById(`q_${qId}_${gId}`).appendChild(instance.$el);
    },
    generateMissingWords(q) {
      let rv = this.mode == 4 ? q.q : q.s1;
      //console.log('generateMissingWords=> ', q, q.agc, rv, force);
      for (let k = 1; k <= q.agc; k++) {
        let bldr = `<span id='q_${this.mode == 0 ? q.id : q.qId}_${k}'></span>`;
        rv = rv.replace("{" + k + "}", bldr);
      }
      return rv;
    },
    missingChanged(obj) {
      //console.log(obj);
      let _q = this.form.questions.filter(
        x => (this.mode == 0 ? x.id : x.qId) == obj.qId
      );
      //console.log(_q);
      if (_q.length) {
        _q = _q[0];
        let _a;
        if (this.mode == 0) {
          _a = _q.a.filter(x => x.id == obj.aId);
        } else {
          _a = _q.as.filter(x => x.aId == obj.aId);
        }

        if (_a.length) {
          _a = _a[0];
          this.submitExamQuestion(_q, _a, obj.gId);
        } else {
          this.submitExamQuestion(_q, null, obj.gId);
        }
      }
    },
    generateMissingWordsFilled(q) {
      let rv = q.q;
      for (let k = 1; k <= q.answerGroupCount; k++) {
        let at = q.as.filter(x => x.g == k);
        let bldr = ``;
        if (at.length) {
          if (at.filter(x => x["if"] == true && x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-success">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span>`;
          } else if (
            at.filter(x => x["if"] == true && x["isTrue"] != true).length
          ) {
            bldr = `<span class="badge badge-danger">${
              at.filter(x => x["if"] == true)[0].a
            }</span>`;
            bldr += ` ( <span class="badge badge-success">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span> )`;
          } else if (at.filter(x => x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-warning">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span>`;
          }
        }

        rv = rv.replace("{" + k + "}", bldr);
      }
      //console.log(q);
      return rv;
    },
    sortedAnswers(q) {
      let rv = [];
      rv = _.orderBy(q.as, ["sec"], ["asc"]);
      return rv;
    }
  },
  // computed: {
  //   showRightSideBar() {
  //     return this.rightSideBar;
  //   }
  // },
  // watch: {
  //   rightSideBar: function(newVal, oldVal) { // watch it
  //     console.log(newVal, oldVal)
  //     this.showRightSideBar = newVal
  //   }
  // },
  computed: {
    showRightSideBar: {
      // getter
      get: function() {
        return this.rightSideBar;
      },
      // setter
      set: function() {
        // var names = newValue.split(' ')
        // this.firstName = names[0]
        // this.lastName = names[names.length - 1]
      }
    }
  }
  // watch: {
  //   watchedZzzz(val) {
  //     if(val)
  //     this.showRightSideBar=true;
  //   }
  // }
};
</script>

<style lang="scss">
.qanchors-outer.invalid {
  border: 1px solid rgba(255, 0, 0, 0.2);
}
.qanchors-outer.invalid .qanchors {
  background: rgba(255, 0, 0, 0.03);
  color: red;
}
.qanchors:hover {
  background: rgba(0, 0, 0, 0.2);
}

.full-mdl{
  .modal-dialog{
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    .modal-content{
      // background-color: #f5f6fa;
    }
  }
}
</style>
